import { withTranslate } from "@pathwright/ui/src/components/"
import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Fullscreen, {
  FULLSCREEN_LAYER_OVERLAY
} from "@pathwright/ui/src/components/fullscreen/Fullscreen"
import View from "@pathwright/ui/src/components/ui/View"
import PropTypes from "prop-types"
import styled from "styled-components"

const Wrapper = styled(View)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`

export const ErrorOverlay = ({ error, explanation, onReload, inline, t }) => {
  if (!error) {
    return null
  }

  const errorUI = (
    <Wrapper padding>
      <View.Primary rounded>
        <BlankSlate
          icon="caution-triangle"
          heading={error.replace("Error: GraphQL error: ", "")}
          body={explanation || t("blocks.errors.default_explanation")}
          primaryAction={{
            children: t("blocks.errors.reload"),
            onClick: onReload
          }}
        />
      </View.Primary>
    </Wrapper>
  )

  // Avoid Fullscreen when testing b/c React Testing Library can't find the modal
  return inline || process.env.NODE_ENV === "test" ? (
    errorUI
  ) : (
    <Fullscreen
      layer={FULLSCREEN_LAYER_OVERLAY}
      background={{
        overlay: "rgba(0,0,0,.6)"
      }}
    >
      {errorUI}
    </Fullscreen>
  )
}

ErrorOverlay.propTypes = {
  onReload: PropTypes.func,
  error: PropTypes.string,
  explanation: PropTypes.string,
  inline: PropTypes.bool
}

ErrorOverlay.defaultProps = {
  onReload: () => window.location.reload(),
  error: "Oops, it looks like we ran into a problem!",
  inline: false
}

export default withTranslate(ErrorOverlay)
